import { isArray, isObject } from 'lodash';
import Input from '@/mixins/Input';

export default {
  mixins: [Input],
  props: {
    value: null,
    collection: null,
  },
  computed: {
    options() {
      const options = [];
      if (isArray(this.collection)) {
        this.collection.forEach((item) => {
          let option;
          if (isObject(item)) {
            option = item;
          } else {
            option = { label: item, value: item };
          }
          options.push(option);
        });
      } else if (isObject(this.collection)) {
        Object.keys(this.collection).forEach((label) => {
          const value = this.collection[label];
          options.push({ label, value });
        });
      }
      return options;
    },
  },
};



// WEBPACK FOOTER //
// ./mixins/InputWithOptions.js